import { MdCheck, MdClose, MdOpenInNew } from "react-icons/md";

const baseBtn =
  "inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed";

const RowActions = ({ onApprove, onReject, onView, busy }) => {
  return (
    <div className="flex items-center gap-2">
      {onApprove ? (
        <button
          type="button"
          disabled={busy}
          onClick={onApprove}
          className={`${baseBtn} bg-success-50 text-success-700 hover:bg-success-100`}
        >
          <MdCheck className="h-4 w-4" />
          قبول
        </button>
      ) : null}
      {onReject ? (
        <button
          type="button"
          disabled={busy}
          onClick={onReject}
          className={`${baseBtn} bg-danger-50 text-danger-700 hover:bg-danger-100`}
        >
          <MdClose className="h-4 w-4" />
          رفض
        </button>
      ) : null}
      {onView ? (
        <button
          type="button"
          onClick={onView}
          className={`${baseBtn} bg-gray-100 text-gray-700 hover:bg-gray-200`}
        >
          <MdOpenInNew className="h-4 w-4" />
          تفاصيل
        </button>
      ) : null}
    </div>
  );
};

export default RowActions;
